export default __webpack_public_path__ + "static/rosen_thumbnail-7d25651b64f6b39927b33939cd06695f.png";